import React, { useState, useContext, useEffect } from 'react';
import { Modal, Form, InputGroup, Col, Row, Spinner } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { NotificationContext } from '../../contexts/notification-context';
import { FaLock } from 'react-icons/fa';
import authService from '../../api/authService';
import './index.css';
import ButtonSubmit from '../../components/button';
import { useAuth } from '../../contexts/auth-context';

const RedefinicaoSenha = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const { addNotification } = useContext(NotificationContext);
  const [tokenValido, setTokenValido] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    email: '',
    newPassword: '',
    confirmPassword: '',
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    if (token) {
      authService.validarTokenRedefinicaoSenha(token)
        .then(() => setTokenValido(true))
        .catch(() => {
          addNotification('danger', 'Token inválido ou expirado.');
          navigate('/login');
        });
    }
  }, [location, navigate, addNotification]);

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{6,}$/;
    return regex.test(password);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Atualizar os dados do formulário
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Validação específica para o campo de senha
    if (name === 'newPassword') {
      if (!validatePassword(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          newPassword: 'A senha deve ter pelo menos 6 caracteres, incluindo letra maiúscula, minúscula, número e caractere especial.',
        }));
      } else {
        setErrors((prevErrors) => {
          const { newPassword, ...rest } = prevErrors;
          return rest; // Remove o erro do campo se for válido
        });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { newPassword, confirmPassword } = formData;

    if (newPassword !== confirmPassword) {
      setErrors({ confirmPassword: 'As senhas não coincidem.' });
      addNotification('danger', 'As senhas não coincidem.');
      return;
    }

    if (!validatePassword(newPassword)) {
      setErrors({ newPassword: 'A senha deve atender aos critérios de segurança.' });
      addNotification('danger', 'A senha não atende aos requisitos de segurança.');
      return;
    }

    setLoading(true);
    setErrors({});

    try {
      const token = new URLSearchParams(location.search).get('token');
      setLoading(true);

      const response = await authService.redefinirSenha(token, newPassword);
    
      addNotification('success', 'Senha redefinida com sucesso!');
      
      try {
        const userData = await authService.login({ email: response.email, senha: newPassword });
        if (userData) {
          login(userData);
          addNotification('success', 'Login realizado com sucesso!');
          navigate('/home');
        }
      } catch (loginError) {
        addNotification('danger', 'Senha redefinida, mas houve um problema ao fazer o login. Por favor, tente logar manualmente.');
        navigate('/login');
      }
    
    } catch (error) {
      addNotification('danger', error.response?.data?.message || 'Erro ao redefinir a senha. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }    
  };

  return (
    <div className="reset-container">
      <Modal show={true} centered onHide={() => navigate('/login')}>
        <Modal.Header closeButton>
          <Modal.Title>Redefinir Senha</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={12}>
                <InputGroup>
                  <InputGroup.Text>
                    <FaLock />
                  </InputGroup.Text>
                  <Form.Control
                    type="password"
                    name="newPassword"
                    placeholder="Nova senha"
                    value={formData.newPassword}
                    onChange={handleChange}
                    isInvalid={!!errors.newPassword}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.newPassword}
                  </Form.Control.Feedback>
                </InputGroup>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={12}>
                <InputGroup>
                  <InputGroup.Text>
                    <FaLock />
                  </InputGroup.Text>
                  <Form.Control
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirmar senha"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    isInvalid={!!errors.confirmPassword}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.confirmPassword}
                  </Form.Control.Feedback>
                </InputGroup>
              </Col>
            </Row>
            <div className="text-end">
              <ButtonSubmit type="submit" disabled={!tokenValido}>
                {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Redefinir Senha'}
              </ButtonSubmit>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default RedefinicaoSenha;
